export default __webpack_public_path__ + "static/media/05-MALIA_1.da0ba12d.gif";